import React, { Suspense, lazy } from 'react'
import ReactDOM from 'react-dom/client'
import { HashRouter } from 'react-router-dom'
import { WagmiProvider } from 'wagmi'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App'
import AppErrorBoundary from './components/AppErrorBoundary'
import { wagmiConfig } from './web3/config'
import { isPrivyEnabled } from './web3/privyFlag'
import { initTelemetry } from './web3/telemetry'
import { track } from './game/metrics'
import './index.css'

initTelemetry()
track('demo_start') // 1re ouverture — sommet du funnel (dédupliqué par save serveur)
const queryClient = new QueryClient()
// Privy (email/Google → wallet embarqué) ne se charge que si l'App ID est configuré
const PrivyRoot = lazy(() => import('./web3/PrivyRoot'))

const app = (
  <HashRouter>
    <App />
  </HashRouter>
)

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AppErrorBoundary>
      {isPrivyEnabled ? (
        <Suspense fallback={null}>
          <PrivyRoot>{app}</PrivyRoot>
        </Suspense>
      ) : (
        <WagmiProvider config={wagmiConfig}>
          <QueryClientProvider client={queryClient}>{app}</QueryClientProvider>
        </WagmiProvider>
      )}
    </AppErrorBoundary>
  </React.StrictMode>,
)
